/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import {
  Button,
  Col,
  ControlLabel,
  Form,
  FormControl,
  FormGroup,
  Row,
} from 'react-bootstrap';
import Nvl from 'loracoms/Nvl';
import ShowIf from 'loracoms/ShowIf';
import Editable from 'loracoms/Editable';
import FormBlock from 'loracoms/FormBlock';
import Refresher from 'loracoms/Refresher';
import deviceActions from 'loraactions/device';
import IntlMsg from 'lorautils/intl/IntlMsg';
import ErrorSet from 'lorautils/errors/ErrorSet';
import { isInteger } from 'lorautils/checkers/numbers';
import styles from './styles.scss';


const kFcntBitsOptions = [{
  value: 16,
  label: '16',
}, {
  value: 32,
  label: '32',
}];

const propTypes = {
  device: React.PropTypes.object.isRequired,
  deviceId: React.PropTypes.string.isRequired,
  getDevice: React.PropTypes.func.isRequired,
  intl: React.PropTypes.any.isRequired,
  updated: React.PropTypes.object.isRequired,
  updateDevice: React.PropTypes.func.isRequired,
};


class ResetSeq extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      device: props.device,
      errors: new ErrorSet(),
    };
    this.intlMsg = new IntlMsg(props.intl, 'devicedetail.datatoolview.resetseq');
    this.handleEditDown = this.handleEditDown.bind(this);
    this.handleEditBits = this.handleEditBits.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmitBits = this.handleSubmitBits.bind(this);
    this.handleSubmitDown = this.handleSubmitDown.bind(this);
    this.handleResetUp = this.handleResetUp.bind(this);
    this.handleReloadSeq = this.handleReloadSeq.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    const { device, updated } = nextProps;
    if (device !== this.props.device) {
      this.setState({ device });
    }
    if (updated !== this.props.updated) {
      if (updated.status === 'success') {
        const { deviceId, getDevice } = this.props;
        getDevice(deviceId);
      } else if (updated.status === 'failure') {
        const { errors } = this.state;
        this.setState({
          errors: errors.add(updated.error.code, 'submit'),
        });
        const that = this;
        this.timeout = setTimeout(() => {
          that.setState({ errors: errors.remove('submit') });
        }, 3000);
      }
    }
  }

  componentWillUnmount() {
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
  }

  handleEditDown() {
    const { device } = this.state;
    this.setState({
      editDown: true,
      editBits: false,
      editData: device.data,
    });
  }

  handleEditBits() {
    const { device } = this.state;
    this.setState({
      editBits: true,
      editDown: false,
      editData: device.data,
    });
  }

  handleSubmitBits() {
    const { deviceId, updateDevice } = this.props;
    const { editData } = this.state;
    const { fcntbits } = editData;

    updateDevice(deviceId, { fcntbits: Number(fcntbits) });
    this.setState({ editBits: false });
  }

  checkDown(v) {
    const { errors } = this.state;
    if (!isInteger(v, { min: 0, max: 4294967295 })) {
      this.setState({
        errors: errors.add('FE_INVALIDFCNTDOWN', 'fcntdown'),
      });
      return false;
    }
    this.setState({
      errors: errors.remove('fcntdown'),
    });
    return true;
  }

  handleSubmitDown() {
    const { deviceId, updateDevice } = this.props;
    const { editData } = this.state;
    const { fcntdown } = editData;

    if (!this.checkDown(fcntdown)) {
      return;
    }
    updateDevice(deviceId, { fcntdown: Number(fcntdown) });
    this.setState({ editDown: false });
  }

  handleResetUp() {
    const { deviceId, updateDevice } = this.props;
    updateDevice(deviceId, { fcntup: 4294967295 });
  }

  handleChange(data, id) {
    if (id === 'fcntdown') {
      this.checkDown(data.fcntdown);
    }
    this.setState({ editData: data });
  }

  handleReloadSeq() {
    const { deviceId, getDevice } = this.props;
    getDevice(deviceId);
  }
  render() {
    const {
      device = {},
      editData = {},
      editDown = false,
      editBits = false,
      errors,
    } = this.state;

    const {
      data: {
        fcntbits,
        fcntdown,
        fcntup,
      } = {},
      status,
    } = device;

    return (
      <Row>
        <Col md={6}>
          <Form horizontal>
            <FormGroup>
              <Col md={3}>
                <ControlLabel className="aisz-control-label">
                  {this.intlMsg.msg('fcntup')}
                </ControlLabel>
              </Col>
              <Col md={6}>
                <FormControl.Static>
                  {fcntup === 4294967295 ? this.intlMsg.msg('reseted') : fcntup}
                </FormControl.Static>
                <Button bsStyle="aisz-link-warning" onClick={this.handleResetUp}>
                  {this.intlMsg.msg('reset')}
                </Button>
              </Col>
            </FormGroup>
            <FormGroup>
              <Col md={3}>
                <ControlLabel className="aisz-control-label">
                  {this.intlMsg.msg('fcntdown')}
                </ControlLabel>
              </Col>
              <Col md={6}>
                <Editable
                  id="fcntdown"
                  value={fcntdown}
                  edit={editDown}
                  data={editData}
                  formatter={x => (
                    <FormControl.Static>
                      <Nvl val={x} nul="empty" status={status} />
                    </FormControl.Static>
                  )}
                  onChange={this.handleChange}
                />
                <ShowIf if={!editDown}>
                  <Button bsStyle="aisz-link" onClick={this.handleEditDown}>
                    {this.intlMsg.msg('edit')}{' '}
                    <span className="halflings halflings-pencil" />
                  </Button>
                </ShowIf>
                <ShowIf if={editDown}>
                  <ul className={`list-inline ${styles.buttons}`}>
                    <li>
                      <Button
                        bsStyle="aisz-link-warning"
                        onClick={() => this.setState({ editDown: false })}
                      >
                        {this.intlMsg.msg('cancel')}{' '}
                        <span className="halflings halflings-remove" />
                      </Button>
                    </li>
                    <li>
                      <Button
                        bsStyle="aisz-link-success"
                        onClick={this.handleSubmitDown}
                      >
                        {this.intlMsg.msg('ok')}{' '}
                        <span className="halflings halflings-ok" />
                      </Button>
                    </li>
                  </ul>
                </ShowIf>
              </Col>
            </FormGroup>
            <FormGroup>
              <Col md={3}>
                <ControlLabel className="aisz-control-label">
                  {this.intlMsg.msg('fcntbits')}
                </ControlLabel>
              </Col>
              <Col md={6}>
                <Editable
                  id="fcntbits"
                  value={fcntbits}
                  edit={editBits}
                  data={editData}
                  control={{
                    type: 'select',
                    options: kFcntBitsOptions,
                  }}
                  formatter={x => (
                    <FormControl.Static>
                      <Nvl val={x} nul="empty" status={status} />
                    </FormControl.Static>
                  )}
                  onChange={this.handleChange}
                />
                <ShowIf if={!editBits}>
                  <Button bsStyle="aisz-link" onClick={this.handleEditBits}>
                    {this.intlMsg.msg('edit')}{' '}
                    <span className="halflings halflings-pencil" />
                  </Button>
                </ShowIf>
                <ShowIf if={editBits}>
                  <ul className={`list-inline ${styles.buttons}`}>
                    <li>
                      <Button
                        bsStyle="aisz-link-warning"
                        onClick={() => this.setState({ editBits: false })}
                      >
                        {this.intlMsg.msg('cancel')}{' '}
                        <span className="halflings halflings-remove" />
                      </Button>
                    </li>
                    <li>
                      <Button
                        bsStyle="aisz-link-success"
                        onClick={this.handleSubmitBits}
                      >
                        {this.intlMsg.msg('ok')}{' '}
                        <span className="halflings halflings-ok" />
                      </Button>
                    </li>
                  </ul>
                </ShowIf>
              </Col>
            </FormGroup>
            <FormGroup>
              <Col mdOffset={3} md={6}>
                <FormBlock
                  message={(
                    <span>
                      <span className="halflings halflings-warning-sign" />
                      {' '}
                      {this.intlMsg.errorMsg(errors.get('submit'))}
                    </span>
                  )}
                  azStyle="danger"
                  show={errors.has('submit')}
                />
              </Col>
            </FormGroup>
          </Form>
        </Col>
        <Col md={6} className={`text-right ${styles.refresher}`}>
          <Refresher
            onReload={this.handleReloadSeq}
            reloading={status === 'pending'}
          />
        </Col>
      </Row>
    );
  }
}


ResetSeq.propTypes = propTypes;

const mapStateToProps = state => ({
  device: state.device.getDevice,
  updated: state.device.updateDevice,
});

const mapDispatchToProps = {
  getDevice: deviceActions.getDevice,
  updateDevice: deviceActions.updateDevice,
};

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(ResetSeq));




// WEBPACK FOOTER //
// ./src/containers/Application/coms/DeviceDetail/coms/DataToolView/coms/ResetSeq/index.jsx